/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
    PriceToJSONTyped,
} from './Price';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
    ProductToJSONTyped,
} from './Product';
import type { ProductMetadata } from './ProductMetadata';
import {
    ProductMetadataFromJSON,
    ProductMetadataFromJSONTyped,
    ProductMetadataToJSON,
    ProductMetadataToJSONTyped,
} from './ProductMetadata';

/**
 *
 * @export
 * @interface ProductWithMetadata
 */
export interface ProductWithMetadata {
    /**
     *
     * @type {Product}
     * @memberof ProductWithMetadata
     */
    product: Product;
    /**
     *
     * @type {ProductMetadata}
     * @memberof ProductWithMetadata
     */
    metadata: ProductMetadata;
    /**
     *
     * @type {{ [key: string]: Price | null; }}
     * @memberof ProductWithMetadata
     */
    activePrices: { [key: string]: Price | null; };
}

/**
 * Check if a given object implements the ProductWithMetadata interface.
 */
export function instanceOfProductWithMetadata(value: object): value is ProductWithMetadata {
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('activePrices' in value) || value['activePrices'] === undefined) return false;
    return true;
}

export function ProductWithMetadataFromJSON(json: any): ProductWithMetadata {
    return ProductWithMetadataFromJSONTyped(json, false);
}

export function ProductWithMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductWithMetadata {
    if (json == null) {
        return json;
    }
    return {

        'product': ProductFromJSON(json['product']),
        'metadata': ProductMetadataFromJSON(json['metadata']),
        'activePrices': (mapValues(json['active_prices'], PriceFromJSON)),
    };
}

  export function ProductWithMetadataToJSON(json: any): ProductWithMetadata {
      return ProductWithMetadataToJSONTyped(json, false);
  }

  export function ProductWithMetadataToJSONTyped(value?: ProductWithMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'product': ProductToJSON(value['product']),
        'metadata': ProductMetadataToJSON(value['metadata']),
        'active_prices': (mapValues(value['activePrices'], PriceToJSON)),
    };
}
